import React, {
  useContext
} from 'react';

import Icon from '@mdi/react'
import {
  mdiApple,
  mdiAndroid,
} from '@mdi/js'

import { isAndroid } from 'react-device-detect';

import { ThemeContext } from '@dstantwo/ullr-react-components';

import { UllrButton } from '../ui/UllrButton';
import { UllrModal } from '../ui/UllrModal/UllrModal';


function DownloadAppModal(props) {
  const { COLORS } = useContext(ThemeContext);

  const closeModal = () => {
    //close modal
    props.close();
  }

  // real render
  const appStoreUrl = isAndroid
    ? "https://play.google.com/store/apps/details?id=in.futuresp.ullr&hl=en"
    : "https://apps.apple.com/app/apple-store/id1326080673?pt=117819832&ct=ullr.ski&mt=8";

    const appStoreIcon = isAndroid
    ? mdiAndroid
    : mdiApple;
  return (
    <UllrModal
      isOpen={props.isOpen}
      close={closeModal}
      headerTitle={`Continue in the Ullr app?`}
    >
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignSelf: 'stretch',
          marginLeft: 24,
          marginRight: 24,
        }}>
          <div style={{
            marginBottom: 24,
          }}>
            <span>You can view this in your browser, but it's better in the Ullr app!</span>
          </div>
          
          <UllrButton
            style={{
              flex: 1,
              margin: 12,
            }}
            onClick={() => window.open(appStoreUrl, "_blank")}
          >
            <Icon
              path={appStoreIcon}
              title="back icon"
              size={1.0}
              color={COLORS.WHITE}
              style={{ marginRight: '16px' }}
            />
            Download App
          </UllrButton>

          <UllrButton
            style={{
              flex: 1,
              margin: 12,
            }}
            inverse
            onClick={closeModal}
          >
            Continue in browser
          </UllrButton>
        </div>
        
        {/* <div style={{
          display: 'flex',
          flexDirection: 'row',
          alignSelf: 'stretch',
          marginTop: 24
        }}>
          <UllrButton
            style={{
              flex: 1,
              margin: 12,
            }}
            inverse
            onClick={closeModal}
          >
            Cancel
          </UllrButton>
          <UllrButton
            style={{
              flex: 1,
              margin: 12,
            }}
            isLoading={isCreateInvitationButtonLoading}
            onClick={async () => {
              setIsCreateInvitationButtonLoading(true);
              const emailIsValid = await emailRef.current.validate(emailInput);
              if (emailIsValid) {
                props.createInvitation({
                  inviteeEmail: emailInput,
                  role: selectedRole,
                })
                  .finally(() => {
                    closeModal();
                    setIsCreateInvitationButtonLoading(false);
                  });
                
              } else {
                setIsCreateInvitationButtonLoading(false)
              }
            }}
          >
            Invite
          </UllrButton>
        </div> */}
      </div>
    </UllrModal>
  );  
}

export default DownloadAppModal;
